import type React from 'react';

export interface CloseIconProps {
	width?: number;
	height?: number;
	fill?: string;
	stroke?: string;
	'aria-label'?: string;
}

const CloseIcon: React.FC<CloseIconProps> = ({
	width = 13,
	height = 14,
	fill = 'none',
	stroke = 'black',
	'aria-label': ariaLabel = 'Close',
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 13 14"
			fill={fill}
			stroke={stroke}
			xmlns="http://www.w3.org/2000/svg"
			aria-label={ariaLabel}
		>
			<title>Close Icon</title>
			<path d="M1 1L12.5 13" stroke="black" />
			<path d="M12.5 1L0.999999 13" stroke="black" />
		</svg>
	);
};

export default CloseIcon;
